// extracted by mini-css-extract-plugin
module.exports = {"layout":"MainLayout_layout__3Ey-8","primary":"MainLayout_primary__396oG","secondary":"MainLayout_secondary__SNG5E","publisherCabinet":"MainLayout_publisherCabinet__-RkXV"};